export default __webpack_public_path__ + "static/DS-K1T500SF1-finger-ada013ba3e1d6d9901ec74894d5263f6.png";